import { render, staticRenderFns } from "./Visar.vue?vue&type=template&id=38ea0c84"
import script from "./Visar.vue?vue&type=script&lang=ts"
export * from "./Visar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports